import "../../theming/streamdown-tailwind.css";
import * as React from "react";
import { Streamdown, defaultRemarkPlugins } from "streamdown";
import { code } from "@streamdown/code";
import rehypeRaw from "rehype-raw";
import { plainElements, plainStrong, plainInlineCode } from "./MarkdownElements";

// A minimal, static-only markdown renderer for internal content (error details, alerts,
// diagnostics).  The full-featured component (streaming, mermaid, qerent blocks, TOC) lives in
// src/viewer/components/Markdown — the two must stay separate: JsxRenderer renders its parse
// errors through this component, and the viewer component renders JsxRenderer.
// NOTE: everything passed to <Streamdown> as an object/array must be referentially stable
// (module-level) — see the viewer component for details...
const plugins = { code };
const remarkPlugins = Object.values(defaultRemarkPlugins);
const rehypePlugins = [rehypeRaw]; // Parity: raw HTML passes through unsanitized (trusted content)
const shikiTheme: [string, string] = ["monokai", "monokai"];
const linkSafety = { enabled: false };
const components = { ...plainElements, strong: plainStrong, inlineCode: plainInlineCode };

type MarkdownProps = {
    content: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ content }) => {
    return (
        <div className="markdown">
            <Streamdown
                mode="static"
                plugins={plugins}
                remarkPlugins={remarkPlugins}
                rehypePlugins={rehypePlugins}
                components={components}
                shikiTheme={shikiTheme}
                lineNumbers={false}
                controls={false}
                codeBlockMaxHeight={0}
                tableMaxHeight={0}
                linkSafety={linkSafety}
            >
                {content}
            </Streamdown>
        </div>
    );
}
